export default function() {
	if($('.js-scrollbar').length) {
		$('.js-scrollbar').each(function(index,el){
			new SimpleBar(el, { autoHide: false });
		});
	}
}
